"use client";

import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useImportProducts } from "@/hooks/api/useProductMutations";

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
};

export function BulkImportModal({ open, onOpenChange }: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [result, setResult] = useState<{
    success_count: number;
    error_count: number;
    errors: { row: number; message: string }[];
  } | null>(null);
  const imp = useImportProducts();

  async function onUpload() {
    if (!file) {
      return;
    }
    try {
      const r = await imp.mutateAsync(file);
      setResult(r);
    } catch {
      setResult({ success_count: 0, error_count: 1, errors: [{ row: 0, message: "Upload failed" }] });
    }
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        onOpenChange(v);
        if (!v) {
          setFile(null);
          setResult(null);
        }
      }}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Bulk import (Excel)</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">
          Columns: Name, SKU, Barcode, Category, Unit, HSN, GST% or GST, Cost, Selling, MRP, Min Stock
        </p>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          className="text-sm"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        />
        <Button type="button" onClick={onUpload} disabled={!file || imp.isPending}>
          {imp.isPending ? "Importing…" : "Upload & import"}
        </Button>
        {result ? (
          <div className="max-h-48 overflow-auto rounded border bg-muted/30 p-2 text-xs">
            <p>
              OK: {result.success_count} · Errors: {result.error_count}
            </p>
            <ul className="mt-1 list-inside list-disc space-y-0.5">
              {result.errors.slice(0, 30).map((e) => (
                <li key={`${e.row}-${e.message}`}>
                  Row {e.row}: {e.message}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
